var map = {
	"./arrowright.svg": 5858,
	"./b24Image.svg": 44114,
	"./challengeicon.svg": 39531,
	"./chart.svg": 44195,
	"./checked_icon.svg": 95424,
	"./circle.svg": 42357,
	"./circles.svg": 16860,
	"./closebtn.svg": 90149,
	"./correct_symbol.svg": 39160,
	"./cross-mark.svg": 80395,
	"./crossmark_black.svg": 15428,
	"./envelope.svg": 41217,
	"./eye-cross.svg": 19167,
	"./eye.svg": 58640,
	"./graph.svg": 39399,
	"./hamburger_menu.svg": 58588,
	"./hamburger_menu_open.svg": 21599,
	"./haoticcircle.svg": 24625,
	"./leftswiperarrow.svg": 59261,
	"./lock.svg": 38904,
	"./loginBackground.svg": 11664,
	"./logout.svg": 70459,
	"./minilogo.svg": 51637,
	"./nav_1.svg": 67428,
	"./nav_1__active.svg": 15756,
	"./nav_2.svg": 21879,
	"./nav_2__active.svg": 22319,
	"./nav_3.svg": 16550,
	"./nav_3__active.svg": 85430,
	"./nav_4.svg": 2313,
	"./nav_4__active.svg": 87417,
	"./nav_5.svg": 76952,
	"./nav_5__active.svg": 57608,
	"./nav_6.svg": 35019,
	"./nav_6__active.svg": 46251,
	"./nav_hover.svg": 53135,
	"./organ.svg": 82792,
	"./organ_active.svg": 57741,
	"./organblue.svg": 81588,
	"./pdf_download.svg": 84344,
	"./rightdownarrow.svg": 80292,
	"./rightswiperarrow.svg": 14712,
	"./rightuparrow.svg": 95009,
	"./rightyellowarrow.svg": 87836,
	"./score-white.svg": 26053,
	"./unchecked_icon.svg": 83453,
	"./unnderline.svg": 2381
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92869;